<button
  class="btn-app-header actions-menu-item"
  nf-button="secondary"
  [icon]="icon"
  [loading]="isLoading"
  [disabled]="isDisabled"
  [ngClass]="{ active: isActive }"
>
  <ng-content></ng-content>
  <span class="badge" *ngIf="badgeCount > 0" [ngClass]="badgeColor">{{
    badgeCount
  }}</span>
</button>
